// User reducer types
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED";
export const SET_USER = "SET_USER";
export const LOADING_USER = "LOADING_USER";
export const MARK_NOTIFICATIONS_READ = "MARK_NOTIFICATIONS_READ";
export const ADD_BOOKMARK = "ADD_BOOKMARK";
export const REMOVE_BOOKMARK = "REMOVE_BOOKMARK";
export const APPROVE_FOLLOW_REQUEST = "APPROVE_FOLLOW_REQUEST";
export const DENY_FOLLOW_REQUEST = "DENY_FOLLOW_REQUEST";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const CLEAR_NOTIFICATION_TO_DELETE = "CLEAR_NOTIFICATION_TO_DELETE";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const GET_MESSAGES = "GET_MESSAGES";
export const GET_MESSAGES_GROUP = "GET_MESSAGES_GROUP";
export const SET_LOADING_CHAT = "SET_LOADING_CHAT";
export const STOP_LOADING_CHAT = "STOP_LOADING_CHAT";
export const ADD_CHAT = "ADD_CHAT";
export const ADD_CHAT_NOTIFICATION = "ADD_CHAT_NOTIFICATION";
export const READ_CHATS = "READ_CHATS";
export const ADD_CONVERSATION = "ADD_CONVERSATION";

// UI reducer types
export const SET_ERRORS = "SET_ERRORS";
export const LOADING_UI = "LOADING_UI";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const LOADING_DATA = "LOADING_DATA";
export const STOP_LOADING_UI = "STOP_LOADING_UI";
export const SET_HOME_PAGE = "SET_HOME_PAGE";
export const SET_SCREAMS_AND_PROFILE = "SET_SCREAMS_AND_PROFILE";
export const SET_SEARCH_NAVBAR = "SET_SEARCH_NAVBAR";
export const SET_PAGINATION = "SET_PAGINATION";
export const RESET_PAGINATION = "RESET_PAGINATION";

// Data reducer types
export const SET_SCREAMS = "SET_SCREAMS";
export const SET_SCREAM = "SET_SCREAM";
export const LIKE_SCREAM = "LIKE_SCREAM";
export const UNLIKE_SCREAM = "UNLIKE_SCREAM";
export const GET_COMMENTS = "GET_COMMENTS";
export const INCREASE_COMMENT_PAGINATION = "INCREASE_COMMENT_PAGINATION";
export const LOADING_PAGINATION = "LOADING_PAGINATION";
export const DELETE_SCREAM = "DELETE_SCREAM";
export const POST_SCREAM = "POST_SCREAM";
export const SUBMIT_COMMENT = "SUBMIT_COMMENT";
export const FOLLOW_USER = "FOLLOW_USER";
export const UNFOLLOW_USER = "UNFOLLOW_USER";
export const STOP_LOADING_DATA = "STOP_LOADING_DATA";
export const LOADING_BUTTON = "LOADING_BUTTON";
export const STOP_LOADING_BUTTON = "STOP_LOADING_BUTTON";
export const INCREASE_OFFSET = "INCREASE_OFFSET";
export const ADD_SCREAMS = "ADD_SCREAMS";
export const NOT_AUTHENTICATED = "NOT_AUTHENTICATED";
export const CLEAR_DATA_ERROR = "CLEAR_ERROR";
